<template>
    <div>
        <Row>
        <i-col span="22">
        </i-col>
        <i-col span="2">
            <Button type="primary" @click="add" v-if="privilegesbtn('/role/create')">新增</Button>  
        </i-col>
    </Row>
       
   
        <Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page :total="total" :current="page" @on-change="changePage" :page-size="pagesize" show-total></Page>
            </div>
        </div>
    </div>
</template>
<script>
import { rolelist, roledelete } from "../../api/roleapi";
import roletable from "./roletable.vue";
import privilegesbtn from "../../constant/privilegesbtn.js";
export default {
  data() {
    return {
      self: this,
      tableData: [],
      total: 0,
      page: 1,
      pagesize: 10,
      isupdte: privilegesbtn("/role/update"),
      isdelete: privilegesbtn("/role/delete"),
      formInline: {
        keywords: ""
      },
      tableColumns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(roletable, {
              props: {
                tableData: params.row.privilege
              }
            });
          }
        },
        {
          title: "用户名",
          key: "name",
          align: "center"
        },
        {
          title: "操作",
          key: "action",
          align: "center",

          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled: !this.isupdte
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.show(params.row);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    disabled: !this.isdelete
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ]
    };
  },
  methods: {
    privilegesbtn:privilegesbtn,
    mockTableData() {
      let para = {
        page: this.page,
        pagesize: this.pagesize
      };
      this.$Loading.start();
      rolelist(para).then(res => {
        this.$Loading.finish();
        var Data = res.data;
        this.total = Data.data.total;
        this.tableData = Data.data.data;
      });
    },
    adminlock(param) {
      let para = {
        id: param.id
      };
      this.$Loading.start();
      lockadmin(para).then(res => {
        this.$Loading.finish();
        var data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
        } else {
          this.changePage(this.page);
          this.$Message.error(data.message);
        }
      });
    },
    show(param) {
      if (param) {
        param.privilege=JSON.stringify(param.privilege)
        this.$router.push({ path: "/roleupdte", query: param });
      }
    },
    add() {
      this.$router.push({ path: "/roleadd" });
    },
    remove(index) {
      let self = this;
      this.$Modal.confirm({
        title: "角色列表",
        content: `是否删除此记录`,
        onOk: function() {
          this.$Loading.start();
          let para = { id: index };
          roledelete(para).then(res => {
            let data = res.data;
            if (data.code == 1) {
              self.$Message.success(data.message);
              self.changePage(self.page);
            } else {
              self.$Message.error(data.message);
            }
          });
        }
      });
    },
    changePage(row) {
      this.page = row;
      this.mockTableData();
    }
  },
  mounted() {
    this.mockTableData();
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/role/index.vue